import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useUrlBuilder } from '@app/router';
import { trackEvent, EVENTS } from '@app/segment';
import { ProfileIcon } from '@stockx/icons';
import AccountMenu from '../../menu/AccountMenu';

const LoggedInNav = () => {
  const { t } = useTranslation();
  const [showMenu, setShowMenu] = useState(false);
  const buildUrl = useUrlBuilder();

  const onMouseEnter = useCallback(() => {
    setShowMenu(true);
  }, [setShowMenu]);

  const onMouseLeave = useCallback(() => {
    setShowMenu(false);
  }, [setShowMenu]);

  return (
    <li
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      key="myAccount"
      role="presentation"
      data-testid="navbar-menu-myaccount"
    >
      <Link
        to={buildUrl('/profile')}
        aria-label={t('My Account')}
        onClick={() => {
          trackEvent(EVENTS.NAVIGATION_ITEM_CLICKED, {
            label: t('My Account'),
          });
        }}
      >
        <ProfileIcon boxSize={7} />
      </Link>

      {showMenu && (
        <AccountMenu format={'dropdown'} handleClose={setShowMenu} />
      )}
    </li>
  );
};

export default LoggedInNav;
